import type { SuccessBodyQuizSetDetailsRes } from '@/api/gen/_model/successBodyQuizSetDetailsRes';
import { CategoryQuizzesSection } from '../features/category-quizzes/components/CategoryQuizzesSection';
import { OwnerQuizzesSection } from '../features/owner-quizzes/components/OwnerQuizzesSection';
interface QuizRecommendationsSectionProps {
  /** 퀴즈 상세 데이터 */
  quizSetWithQuizList: SuccessBodyQuizSetDetailsRes;
  /** 현재 퀴즈 ID */
  quizId: string;
  /** 내 퀴즈 여부 */
  isMyQuiz: boolean;
}

/**
 * QuizRecommendationsSection - 추천 퀴즈 섹션
 *
 * @description
 * 소유자의 다른 퀴즈와 같은 카테고리 퀴즈를 세로로 나열하여 표시합니다.
 * 각 섹션은 독립적으로 로딩, 에러, 빈 상태를 처리합니다.
 *
 * @example
 * ```tsx
 * <QuizRecommendationsSection
 *   quizSetWithQuizList={quizSetData}
 *   quizId="quiz-123"
 * />
 * ```
 */
export const QuizRecommendationsSection = ({
  quizSetWithQuizList,
  quizId,
  isMyQuiz
}: QuizRecommendationsSectionProps) => {
  return <div className="w-full bg-neutral" data-sentry-component="QuizRecommendationsSection" data-sentry-source-file="QuizRecommendationsSection.tsx">
      <div className="mx-auto flex w-full max-w-[1072px] flex-col gap-lg px-md py-lg empty:py-0 min-[769px]:max-w-[1104px] min-[769px]:px-2xl">
        {/* 소유자의 다른 퀴즈 섹션 - 내 퀴즈일 경우 미노출 */}
        {!isMyQuiz && <OwnerQuizzesSection ownerId={quizSetWithQuizList.data.authorId} authorName={quizSetWithQuizList.data.authorUsername} currentQuizId={quizId} />}

        {/* 같은 카테고리 퀴즈 섹션 */}
        <CategoryQuizzesSection criteria={{
        schoolGrades: quizSetWithQuizList.data.categoryTreeData?.schoolGrade ? [quizSetWithQuizList.data.categoryTreeData.schoolGrade] : undefined,
        schoolType: quizSetWithQuizList.data.categoryTreeData?.schoolType,
        schoolSemesters: quizSetWithQuizList.data.categoryTreeData?.schoolSemester ? [quizSetWithQuizList.data.categoryTreeData.schoolSemester] : undefined,
        // 하단 추천은 "현재 퀴즈의 국가" 기준으로 필터링한다 (뷰어 Geo 아님).
        countryCode: quizSetWithQuizList.data.countryCode
      }} subject={quizSetWithQuizList.data.categoryTreeData?.subSubjectNumber ? quizSetWithQuizList.data.categoryTreeData.subjectNumber + quizSetWithQuizList.data.categoryTreeData.subSubjectNumber : quizSetWithQuizList.data.categoryTreeData?.subjectNumber} categoryTreeData={quizSetWithQuizList.data.categoryTreeData} currentQuizId={quizId} data-sentry-element="CategoryQuizzesSection" data-sentry-source-file="QuizRecommendationsSection.tsx" />
      </div>
    </div>;
};